import http from "../plugins/axios";
const BASE_URI = "/resume";
export default {
  getResumePagination({
    limit,
    currentPage,
    searchByTitle,
    searchByTopic,
    searchByDegreeType
  }) {
    return http.get(
      `${BASE_URI}?limit=${limit}&currentPage=${currentPage}&searchByTitle=${searchByTitle}&searchByTopic=${searchByTopic}&searchByDegreeType=${searchByDegreeType}`
    );
  },
  getSpecialityByTopic({ major }) {
    return http.get(
      `${BASE_URI}/getByTopic?major=${major}`
    );
  },
  uploadFile(formData) {
    return http.post(`${BASE_URI}/uploadFile`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  update(id, data) {
    return http.post(`${BASE_URI}/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  remove(id) {
    return http.delete(`${BASE_URI}/${id}`);
  },
  removeCvs({ id, cvs }) {
    return http.delete(`${BASE_URI}/cvs/${id}?cvs=${cvs}`);
  }
};
